import { Box, Cable, Cctv, Laptop, Monitor, Plane, Printer, Router, Smartphone } from "lucide-react";

const Icons = { Box, Cable, Cctv, Laptop, Monitor, Plane, Printer, Router, Smartphone };
import { Link } from "react-router-dom";
import { Eyebrow, MaskedLines, Reveal } from "../motion/Reveal";
import { shopCategories } from "../../content/site";

export const CategoryTile = ({ c, i, dark = false }) => {
  const Icon = Icons[c.icon] ?? Icons.Box;
  return (
    <Reveal delay={(i % 4) * 0.06}>
      <div data-testid={`shop-category-${c.name.toLowerCase().replace(/\W+/g, "-")}`}
        className={`group relative flex min-h-[190px] flex-col justify-between overflow-hidden rounded-[22px] border p-5 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1 sm:min-h-[220px] sm:p-6 ${dark ? "border-white/10 bg-gradient-to-b from-[#17120F] to-[#100D0B] hover:border-orange-500/50 hover:shadow-[0_24px_60px_-30px_rgba(234,88,12,0.5)]" : "border-stone-300 bg-white hover:border-orange-600 hover:shadow-[0_24px_50px_-30px_rgba(194,65,12,0.35)]"}`}>
        <span aria-hidden="true" className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-orange-500/0 blur-2xl transition-colors duration-700 group-hover:bg-orange-500/20" />
        <span className="relative flex items-center justify-between">
          <span className={`font-mono text-[10px] ${dark ? "text-stone-400" : "text-stone-500"}`}>0{i + 1}</span>
          <span className={`rounded-full border px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.15em] ${dark ? "border-orange-500/30 text-orange-300" : "border-orange-700/30 text-orange-800"}`}>Coming soon</span>
        </span>
        <span className={`relative grid h-14 w-14 place-items-center rounded-2xl border transition-[transform,border-color] duration-700 group-hover:-translate-y-1 group-hover:rotate-[-4deg] ${dark ? "border-white/10 bg-white/[0.03]" : "border-stone-200 bg-stone-50"}`}>
          <Icon strokeWidth={1.3} className={`h-7 w-7 ${dark ? "text-orange-400" : "text-orange-700"}`} />
        </span>
        <span className="relative">
          <span className={`block font-display text-base leading-tight sm:text-lg ${dark ? "text-stone-100" : "text-stone-900"}`}>{c.name}</span>
          <span className={`mt-1 block text-xs ${dark ? "text-stone-400" : "text-stone-500"}`}>Selection · setup · support</span>
        </span>
      </div>
    </Reveal>
  );
};

export const ShopTeaser = () => (
  <section id="care-shop" data-testid="shop-teaser-section" className="tc-sheet bg-[#F5F5F4] py-24 text-stone-900 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow light>07 — Care-Shop · Coming soon</Eyebrow>
          <h2 className="mt-8 font-display text-4xl font-medium leading-[1] tracking-tight sm:text-6xl">
            <MaskedLines inView lines={["Technology,", <span key="t" className="text-orange-700">taken care of.</span>]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-5">
          <p className="text-base leading-relaxed text-stone-600">
            A future TechCare store for business and personal technology — chosen with the same care as our services.
            The shop is not open yet; join the list to hear when it launches.
          </p>
          <Link to="/shop" data-testid="shop-teaser-cta" className="mt-6 inline-flex h-12 items-center rounded-full bg-stone-900 px-6 text-sm font-semibold text-white transition-colors duration-300 hover:bg-orange-700">
            Get launch updates
          </Link>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {shopCategories.map((c, i) => <CategoryTile key={c.name} c={c} i={i} />)}
      </div>
    </div>
  </section>
);
